// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const GifOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 576 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M512 80c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h448zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm240 124c-11 0-20 9-20 20v160c0 11 9 20 20 20s20-9 20-20V176c0-11-9-20-20-20zm52 20v160c0 11 9 20 20 20s20-9 20-20v-60h52c11 0 20-9 20-20s-9-20-20-20h-52v-40h68c11 0 20-9 20-20s-9-20-20-20h-88c-11 0-20 9-20 20zm-224 80c0-33.1 26.9-60 60-60 13.5 0 26 4.5 36 12 8.8 6.6 21.4 4.9 28-4s4.9-21.4-4-28a99.26 99.26 0 00-60-20c-55.2 0-100 44.8-100 100s44.8 100 100 100c22.5 0 43.3-7.4 60-20 5-3.8 8-9.7 8-16v-56c0-11-9-20-20-20h-56c-11 0-20 9-20 20s9 20 20 20h36v25.1a60.05 60.05 0 01-88-53.1z"}}]},"name":"gif","theme":"outlined"};

const GifOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={GifOutlinedSvg} />;
  GifOutlined.displayName = 'GifOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(GifOutlined);
